import { render, staticRenderFns } from "./PhotovoltaicDiagram.vue?vue&type=template&id=23d5f605&scoped=true"
import script from "./PhotovoltaicDiagram.vue?vue&type=script&lang=js"
export * from "./PhotovoltaicDiagram.vue?vue&type=script&lang=js"
import style0 from "./PhotovoltaicDiagram.vue?vue&type=style&index=0&id=23d5f605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d5f605",
  null
  
)

export default component.exports